export const incomesListArray = [
  {
    id: "c7040861-bca7-40bd-b4ec-e15f70850435",
    type: "income",
    name: "Monthly Salary",
    amount: 2500,
    category: "Work"
  },
  {
    id: "7ed34af5-60bc-4f45-b577-cc3754e2bcb7",
    type: "income",
    name: "Lottery win",
    amount: 150,
    category: "Hobby"
  },
  {
    id: "665bf81d-b315-4015-b31c-1134c628cc80",
    type: "income",
    name: "Math lessons",
    amount: 330,
    category: "Work"
  }
];
